import { MATERIAL_VIP_VERSION } from "@/constants/gaodingVip";
import useAppStore from "@/context/store";
import { getCurrentOrg, getGdVipInfo } from "@/services";
import dayjs from "dayjs";
import minMax from "dayjs/plugin/minMax";
import { maxBy } from "lodash";
import {
  filterGdDesignVip,
  filterMaterailVip,
  getGdProductDetail,
} from "../gaodingVip";
import useReq from "../useReq";
dayjs.extend(minMax);

const cacheKey = "gd-vip-info";

function getMaxExpireDate(expireArr: (string | Date | number)[]) {
  // 过滤空的
  const arr = expireArr.filter((item) => item);

  // 没有值，返回空
  if (arr.length === 0) {
    return null;
  }

  // 有值就返回最大的过期时间
  return maxBy(arr, (item) => {
    return dayjs(item).valueOf();
  });
}

export function useGdVipInfo() {
  const user = useAppStore((s) => s.user);

  const { data, refresh } = useReq(
    async () => {
      if (!user) {
        return null;
      }

      const [orgInfo, vipInfo] = await Promise.all([
        getCurrentOrg({
          api_info_types:
            "VISITOR_SEAT_RIGHT_INFO,SEAT_RIGHT_INFO,MATERIAL_SEAT_RIGHT_INFO",
        }),
        getGdVipInfo({
          embed: "vip_subscription,pending_vips",
        }),
      ]);

      const productDetial = getGdProductDetail(orgInfo);

      // 素材会员
      const materialVip = filterMaterailVip(vipInfo?.vip, {
        includeExpired: true,
      });

      // 待生效会员
      // const pendingMaterialVip = filterMaterailVip(vipInfo?.pending_vips);

      // 素材会员过期时间，默认取 企业信息接口里的过期时间（会自动加上待生效的）
      // 当没一体化版本里没有过期时间时，取会员里的过期时间 （会员过期时，一体化版本会退回免费版，没有过期时间，这时候要取vips里的信息，用于展示什么时候过期）
      const materialExprieDate =
        productDetial?.materialProductMod?.product_info?.expire_date ||
        materialVip?.[0]?.expires_at;

      /**素材会员是否过期 */
      const isMaterialVipExpired = new Date(materialExprieDate) <= new Date();

      /**稿定模板会员*/
      const gdesignVip = filterGdDesignVip(vipInfo?.vip, {
        includeExpired: true,
      });

      const gdesignExprieDate =
        productDetial?.gdesignProductMod?.product_info?.expire_date ||
        gdesignVip?.[0]?.expires_at;

      const isGdesignVipExpired = new Date(gdesignExprieDate) < new Date();

      /**素材会员版本信息，包含授权类型与授权文案 */
      const materialVipVersion =
        MATERIAL_VIP_VERSION[materialVip[0]?.solution_version];

      // 一体化版本过期时间
      const productExpireDate =
        orgInfo.product?.expire_date &&
        getMaxExpireDate([materialExprieDate, gdesignExprieDate]);

      return {
        ...productDetial,
        ...orgInfo,
        /**所有会员详情信息 */
        vipInfo,
        /**整体一体化版本过期时间 */
        productExpireDate,
        /**素材会员是否过期 */
        isMaterialVipExpired,
        /**素材会员版本信息，包含授权类型与授权文案 */
        materialVipVersion,
        /**素材会员 */
        materialVip,
        /**素材会员过期时间 */
        materialExprieDate,
        /**稿定模板会员 */
        gdesignVip,
        /**稿定模板会员过期时间 */
        gdesignExprieDate,
        /**稿定模板会员是否过期 */
        isGdesignVipExpired,
      };
    },
    {
      cacheKey,
      cacheTime: 60 * 1000,
      refreshDeps: [user?.extra?.org_id],
    }
  );

  return { data, refresh };
}
